module.exports = __webpack_public_path__ + "2ba078ad2e86488d8eca8c04aa4810af.MP3";